<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">General/Non-Inventory Receipts</h4>
                <p class="text-subtitle-1">Non-Inventory Receipts for Purchase Orders</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false" min-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            block
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <GeneralReceiptListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <GeneralReceiptList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GeneralReceiptListSearch from "./../../components/purchase/GeneralReceiptListSearch.vue"
import GeneralReceiptList from "./../../components/purchase/GeneralReceiptList.vue"
import { mapActions } from 'vuex'
export default {
    name: "GeneralReceiptListView",
    components: {
        GeneralReceiptList,
        GeneralReceiptListSearch
    },
    methods: {
        ...mapActions({
            refresh: "purchase/goodReceipt/search",
            updateParams: "purchase/goodReceipt/updateParams"
        })
    },
    mounted() {
        if(this.$route.query.order_code) {
            this.updateParams({purchase_order_code: this.$route.query.order_code})
        }
    }
}
</script>

<style>

</style>